<template>
  <div>
    <Head title="Create Contact" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/creator">Influencer</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.crtr_name" :error="form.errors.crtr_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Full Name" />
          <select-input v-model="form.crtr_is_influencer" :error="form.errors.crtr_is_influencer" class="pb-8 pr-6 w-full lg:w-1/2" label="Influencer">
            <option value="0">Employee</option>
            <option value="1">Influencer</option>
            <option value="2">Anchor</option>
          </select-input>
          <text-input  v-if="form.crtr_is_influencer == 0"  v-model="form.pkm_empl_id" :error="form.errors.pkm_empl_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Employee ID" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Contact</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    creator: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        crtr_name: '',
        crtr_is_influencer: 1,
        pkm_empl_id: undefined
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/creator')
    },
  },
}
</script>
